import React from "react";
import { useSelector } from "react-redux";
import AcademicCalendarView from "../shared/AcademicCalendarView";
import { getSchoolIdForUser } from "../../utils/userContext";

export default function TeacherAcademicCalendar() {
    const { currentUser } = useSelector((s) => s.user);
    const schoolId = getSchoolIdForUser(currentUser);
    return (
        <AcademicCalendarView
            schoolId={schoolId}
            schoolType={currentUser?.schoolType || currentUser?.school?.schoolType || "Secondary"}
            adminMode={false}
        />
    );
}
